import backofficeService from '@/api/backoffice'

export default {
  /**
   * Get list of PriceTiers
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to PriceTiers
   */
  getAll(params) {
    return backofficeService.Api().get('PriceTier', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  
  /**
   * Get specific PriceTier
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to PriceTier
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`PriceTier/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific PriceTier
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to PriceTier
   */
  productById(id, params = {}) {
    return backofficeService.Api().get(`PriceTier/product/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a PriceTier. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('PriceTier', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific PriceTier
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`PriceTier/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete PriceTier
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`PriceTier/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
